import React, { useEffect, useState } from 'react'
import styles from './style.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faLock, faMailBulk, faPhone, faStar, faStarHalfAlt, faUnlock } from '@fortawesome/free-solid-svg-icons';
import userlogo from '../../../assets/images/user.png'
import Empty from '../../../assets/images/EmptyState.svg'
import FileSaver from 'file-saver';
import Pagination from '../../Common/Pagination/Box';
import Modal from '../../Common/Modal'
import CandidateDetail from '../CandidateDetail'
const List = ({ data, limit, setLimit, currentPage, setCurrentPage, onStartEvaluating }) => {
    const [showCandidateDetailModal, setShowCandidateDetailModal] = useState(false)

    const downloadResume = (input) => {
        const RESUME_FILE = input.RESUME_FILE;
        const CANDIDATE_ID = input.CANDIDATE_ID;
        FileSaver.saveAs(
            `${process.env.REACT_APP_BASE_URL}/candidate-resume/${CANDIDATE_ID}/${RESUME_FILE}`,
            RESUME_FILE
        );
    };


    return (
        <React.Fragment>
            <Modal
                isOpen={showCandidateDetailModal}
            >
                <CandidateDetail
                    data={showCandidateDetailModal}
                    onClose={() => { setShowCandidateDetailModal(false) }}
                />

            </Modal>
            <div className={`${styles['order-first']} col-md-12`}>
                {data?.SUGGESTED_PROFILES?.length > 0 &&
                    <div className={`${styles['filter-card']} mb-3`}>
                        <React.Fragment>
                            <div className="row">
                                <div className="col-md-6">
                                    <div>
                                        <label className={`${styles['label-ct']}`}>Show</label>
                                        <select className="form-select d-inline-block w-auto mx-2"
                                            value={limit}
                                            onChange={(e) => { setLimit(e.target.value) }}
                                        >
                                            <option value={10}>10</option>
                                            <option value={20}>20</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                        </select>
                                        <span className={`${styles['label-ct']}`}>Records Per Page</span>
                                    </div>
                                </div>
                                <div className="col-md-6 d-flex justify-content-end">
                                    <Pagination
                                        limit={limit}
                                        totalCount={data?.count}
                                        range={3}
                                        currentPage={currentPage}
                                        onPageChange={(newPage) => { setCurrentPage(newPage) }}
                                    />
                                </div>
                            </div>

                            <hr />

                            <div className="row">
                                <div className="col-md-4">
                                    <div className='d-flex align-items-center'>
                                        <input type="checkbox" id="selectAll" className="form-check-input me-2" />
                                        <label htmlFor="selectAll" className={`${styles['label-ct']} me-4 mt-1`}>
                                            Select All
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-8 d-flex justify-content-end">
                                    <div className={`${styles['w-30']}`}>
                                        <button className={`${styles['edit-btn']} btn`}>
                                            Download Excel<FontAwesomeIcon icon={faDownload} className='ps-2' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>

                    </div>
                }
                {data?.SUGGESTED_PROFILES.map((item) => {
                    const profileSections = [

                        {
                            key: "profileSummary",
                            condition: item.PROFILE_SUMMARY && item.PROFILE_SUMMARY?.length > 0,
                            content: (
                                <p className="mb-1">
                                    <strong>Profile Summary:</strong>{" "}
                                    {item.PROFILE_SUMMARY?.length > 100 ? (
                                        <>
                                            {item.PROFILE_SUMMARY.substring(0, 100)}...
                                            <span className="text-primary ms-1">| Full Profile</span>
                                        </>
                                    ) : (
                                        item.PROFILE_SUMMARY
                                    )}
                                </p>
                            ),
                        },

                        {
                            key: "experience",
                            condition:
                                (item.TOTAL_EXP_YEAR != null && item.TOTAL_EXP_YEAR !== 0) ||
                                (item.TOTAL_EXP_MONTH != null && item.TOTAL_EXP_MONTH !== 0),
                            content: (
                                <p className="mb-1">
                                    <strong>Experience:</strong>{" "}
                                    {item.TOTAL_EXP_YEAR ? `${item.TOTAL_EXP_YEAR} Years` : ""}
                                    {item.TOTAL_EXP_YEAR && item.TOTAL_EXP_MONTH ? " " : ""}
                                    {item.TOTAL_EXP_MONTH ? `${item.TOTAL_EXP_MONTH} Months` : ""}
                                </p>
                            ),
                        },

                        {
                            key: "salary",
                            condition: item.CTC && item.CTC != null && item.CTC !== 0,
                            content: (
                                <p className="mb-1">
                                    <strong>Salary:</strong> ₹{item.CTC.toLocaleString()}
                                </p>
                            ),
                        },

                        {
                            key: "education",
                            condition: item.EDUCATION,
                            content: (
                                <>
                                    <h6>Education</h6>
                                    <p>{item.EDUCATION}</p>
                                </>
                            ),
                        },
                        {
                            key: "industry",
                            condition: item.INDUSTRY,
                            content: <p className="mb-1"><strong>Industry:</strong> {item.INDUSTRY}</p>,
                        },
                        {
                            key: "functionalArea",
                            condition: item.FUNCTIONAL_AREA,
                            content: <p className="mb-1"><strong>Functional Area:</strong> {item.FUNCTIONAL_AREA}</p>,
                        },
                        {
                            key: "location",
                            condition: item.CURRENT_LOCATION,
                            content: <p className="mb-1"><strong>Location:</strong> {item.CURRENT_LOCATION}</p>,
                        },
                        {
                            key: "currentDesignation",
                            condition: item.CURRENT_DESIGNATION,
                            content: (
                                <>
                                    <h6>Current/ Latest</h6>
                                    <p>
                                        {item.CURRENT_DESIGNATION}
                                        {item.CURRENT_COMPANY ? ` at ${item.CURRENT_COMPANY}` : ""}
                                    </p>
                                </>
                            ),
                        },
                        {
                            key: "preferredLocation",
                            condition: Array.isArray(item.prefferedLocation) && item.prefferedLocation?.length > 0,
                            content: (
                                <>
                                    <h6>Preferred Location</h6>
                                    <p>{item.prefferedLocation.map((city) => city.CITY).join(", ")}</p>
                                </>
                            ),
                        },
                        {
                            key: "skills",
                            condition: Array.isArray(item.SKILL) && item.SKILL?.length > 0,
                            content: (
                                <>
                                    <h6>Skills</h6>
                                    <p>{item.SKILL.map((skill) => skill.SKILL).join(" | ")}</p>
                                </>
                            ),
                        },
                        {
                            key: "justification",
                            condition: item.JUSTIFICATION && item.JUSTIFICATION?.length > 0,
                            content: (
                                <p className="mb-1">
                                    <strong>AI Message:</strong>{" "}
                                    {item.JUSTIFICATION?.length > 100 ? (
                                        <>
                                            {item.JUSTIFICATION.substring(0, 200)}...
                                            <span className="text-primary ms-1">| Full Profile</span>
                                        </>
                                    ) : (
                                        item.JUSTIFICATION
                                    )}
                                </p>
                            ),
                        },
                    ];

                    // Filter out sections that have valid conditions
                    const validSections = profileSections.filter(section => section.condition);

                    // Calculate the split index (30% for left, 70% for right)
                    const splitIndex = Math.max(1, Math.floor(validSections.length * 0.3));
                    const leftColumn = validSections.slice(0, splitIndex);
                    const rightColumn = validSections.slice(splitIndex);

                    return (
                        <div className={`${styles['details-card']} card mb-3`}>
                            <div className='row'>
                                <div className="col-md-6">

                                    <div className="d-flex">
                                        <div className="d-flex align-items-center me-3">
                                            <input type="checkbox" className="me-2" />
                                            <div className={styles['circle-container']}>
                                                <img
                                                    src={item.PROFILE_IMAGE ? `${process.env.REACT_APP_BASE_URL}/candidate/pic/${item.CANDIDATE_ID}/${item.PROFILE_IMAGE}` : userlogo}
                                                    alt="profile"
                                                    className={styles['circle-image']}
                                                />
                                            </div>
                                        </div>



                                        <div className={`${styles["profile-section"]}`}>
                                            <h5 className="mb-1">{item.CANDIDATE_NAME}</h5>
                                            <p className="mb-1 d-flex align-items-center">
                                                <FontAwesomeIcon className={`${styles["icon-st"]} me-2`} icon={faPhone} />
                                                {item.PHONENO}
                                            </p>
                                            <p className="mb-1 d-flex align-items-center">
                                                <FontAwesomeIcon className={`${styles["icon-st"]} me-2`} icon={faMailBulk} />
                                                {item.EMAIL_ID}
                                            </p>
                                        </div>
                                    </div>
                                    <button className={`${styles["search-btn"]} btn`}
                                        onClick={() => {
                                            setShowCandidateDetailModal(item)
                                        }}
                                    >
                                        Unlock full Profile<FontAwesomeIcon className='ps-2' icon={faLock} />
                                    </button>
                                    <hr />
                                    <div className="row mb-3">
                                        <div className={`${styles["profile-details"]}`}>
                                            {leftColumn.map(section => section.content)}
                                        </div>
                                    </div>
                                </div>

                                <div className={`${styles["profile-details"]} border-start col-md-6`}>
                                    {rightColumn.map(section => section.content)}
                                </div>

                            </div>
                        </div>
                    )
                })}
                {
                    data?.SUGGESTED_PROFILES?.length === 0 && (
                        <div className={`${styles['details-card']} card mb-3 d-flex justify-content-center align-items-center text-center`}>
                            <div className="row w-100 d-flex justify-content-center">
                                <div className="col-md-6 d-flex flex-column align-items-center">
                                    <img
                                        width={150}
                                        height={150}
                                        src={Empty}
                                        alt="No profiles found"
                                    />
                                    <h4 className="mb-1">No profiles found</h4>
                                    <p>Please modify your search and expand your search criteria.</p>
                                    <button className={`${styles["search-btn"]} btn w-50 mt-2 mb-5`}
                                        onClick={() => {
                                            onStartEvaluating()
                                        }}
                                    >
                                        Start Searching
                                    </button>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>

        </React.Fragment>

    )
}

export default List